import { Grid, Typography } from '@material-ui/core';
import { Link, InfoCard } from '@backstage/core-components';

import { LinkData } from '../../util';

export interface SlackCardProps {
  links: LinkData[];
}

export const SlackCard = (props: SlackCardProps) => {
  const { links } = props;

  if (!links.length) {
    return null;
  }

  return (
    <InfoCard title="Slack Channels">
      <Grid container>
        {links?.map(link => (
          <Grid item key={link.title}>
            <Typography key={link.title} variant="body2">
              <Link to={link.url}>{link.title}</Link>
            </Typography>
          </Grid>
        ))}
      </Grid>
    </InfoCard>
  );
};
